import React, { Component } from 'react'
import { Nav } from './../../../components'
import {Link} from 'react-router-dom'
import { HubQuizzStyle } from './../../../styles'
import Router from './../../../services/Router'
import { GetMonth, DayDiff, DateFormat} from '../../../helpers/date'
import { withLoader } from '../../../hoc/withLoader'

class HubQuizz extends Component {
  state = {
    nav : [
      // {
      //   value: 'Gift',
      //   url: Router.gifts.path
      // },
      {
        value: 'Quizzes',
        url: Router.hubQuizz.path
      },
      {
        value: 'Ranking',
        url: Router.ranking.exactPath
      },
    ],
  }

  render () {
    const { nav } = this.state
    const { data, isReady } = this.props
    return(
      <div className={`hub-quizz page-inner ${HubQuizzStyle()}`}>
        <Nav nav={nav} />
        <div className={`hub-quizz-container transition ${isReady ? 'transition--ready': ''}`}>
          {
           data && Object.keys(data.currentQuiz).length > 0 && (
            <div>
              <h2 className="hub-quizz-title subtitle"> Current Quizz </h2>
              <div className="current-quizz quizz flex items-center">
                <div className="current-quizz-inner quizz-inner flex items-center">
                  <div className="current-quizz-info">
                    <h3>{ data.currentQuiz.title }</h3>
                      <p dangerouslySetInnerHTML={{ '__html': `${DateFormat(data.currentQuiz.start.substring(0, 2))} of ${GetMonth(data.currentQuiz.start.substring(3, 5))} to ${DateFormat(data.currentQuiz.end.substring(0, 2))} of ${GetMonth(data.currentQuiz.end.substring(3, 5))}` }}/>
                    {data.currentQuiz.score && ( <span className="score">{ data.currentQuiz.score } pts</span> ) }
                  </div>
                  <div className="current-quizz-link">
                      <Link to={Router.currentQuizz.path} className="btn"> <span>Start the quizz</span> </Link>
                  </div>
                </div>
                <div className="current-quizz-days">
                  {
                    DayDiff(
                      new Date(),
                      new Date(data.currentQuiz.end.substring(6,10), parseInt(data.currentQuiz.end.substring(3,5)) - 1 ,data.currentQuiz.end.substring(0,2))
                    ) > 0 ? (
                      <div>
                        <span className="days">
                          { data.currentQuiz.enabled ? 
                          DayDiff(
                            new Date(),
                            new Date(data.currentQuiz.end.substring(6, 10), parseInt(data.currentQuiz.end.substring(3, 5)) - 1, data.currentQuiz.end.substring(0, 2))
                          ) : 
                          DayDiff(
                            new Date(),
                            new Date(data.currentQuiz.start.substring(6, 10), parseInt(data.currentQuiz.start.substring(3, 5)) - 1, data.currentQuiz.start.substring(0, 2))
                          )
                        }</span>
                            <span className="label">{data.currentQuiz.enabled && !!data.currentQuiz.score ? 'days left to participate' : 'days to participate'}</span>
                      </div>
                    ) : (
                      <span className="label">You can practice again but your score cannot be taken into account</span>
                    )
                  }
                 
                </div>
              </div>
            </div>
            )
          }
        
          <div className="hub-quizz-previous">
            <h2 className="hub-quizz-title"> Previous Quizz </h2>
            <p> You can practice again but your score cannot be taken into account </p>
            <div className="previous-quizz-container flex items-center">
              {
               data && data.previousQuizzes.map((quizz, index) => (
                  <div className="previous-quizz quizz flex" key={index}>
                    <div className="previous-quizz-inner quizz-inner">
                        <h3>{ quizz.title }</h3>
                        { quizz.score ? <span className="score">{ quizz.score } pts</span> : null}
                    </div>
                    <div className="previous-quizz-days">
                      <p> {quizz.start.substring(0,2)}th of {GetMonth(quizz.start.substring(3,5))} to {quizz.end.substring(0,2)}th of {GetMonth(quizz.end.substring(3,5))} </p>
                      <Link to={`${Router.quizz.exactPath}/${quizz.id}` } className="btn"> <span>Start the quizz</span> </Link>
                    </div>
                  </div>
                ))
              }
            </div>
            { data && data.previousQuizzes.length === 0 && (<p>No previous quizz available at the moment</p>)}
          </div>
        </div>
      </div>
    )
  }
}

export default withLoader(HubQuizz, '/challenge/quiz/all')


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/HubQuizz.js